import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApplicationResponse,  StateTrackedData } from "@src/common/domain/common.model";
import api from "@src/common/services/api.service";
import AppConstants from "@src/utils/app.constants";
import { DeliveryLocationModelRef, DeliveryLocationStore } from "../domain/delivery-location.model";

export const createDeliveryLocation = createAsyncThunk<void, any>(
  "deliveryLocation/createDeliveryLocation",
  async (payload: any) => {
    const url = `${AppConstants.api}/deliveryLocation`;
    const response = await api.post<ApplicationResponse<any>>(
      url,
      payload
    );
    return response.data.data || [];
  }
);
// export const updateDeliveryLocation = createAsyncThunk<void, any>(
//   "deliveryLocation/updateDeliveryLocation",
//   async (id: any,payload:any) => {
//     const url = `${AppConstants.api}/deliveryLocation?id=${id}`;
//     const response = await api.put<ApplicationResponse<any>>(
//       url,
//       payload,
//     );
//     return response.data.data || [];
//   }
// );
export const updateDeliveryLocation = createAsyncThunk<void, { id: string; data: any }>(
  "deliveryLocation/updateDeliveryLocation",
  async ({ id, data }) => {
    try {
      const response = await api.put<ApplicationResponse<any>>(
        `${AppConstants.api}/deliveryLocation?id=${id}`,
        data
      );


      return; 
    } catch (error) {
      // return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const deleteDeliveryLocation = createAsyncThunk(
  "deliveryLocation/deleteDeliveryLocation",
  async (id: string) => {
    try {
      const response = await api.delete<ApplicationResponse<any[]>>(
        `${AppConstants.api}/deliveryLocation?id=${id}`
      );
      return response.data.data || [];
    } catch (err) {
      return [];
    }
  }
);
export const fetchDeliveryLocationList = createAsyncThunk<any[], void>(
    "deliveryLocation/fetchDeliveryLocation",
    async () => {
          const response = await api.get<ApplicationResponse<DeliveryLocationModelRef[]>>(`${AppConstants.api}/deliveryLocation`)
        return response.data.data || []
    }
);

const deliveryLocationSlice = createSlice({
  name: "deliveryLocation",
  initialState: {
    minimal: { status: "loading", error: null, data: [] },
  } as DeliveryLocationStore,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDeliveryLocationList.pending, (state, action) => {
        state.minimal = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(fetchDeliveryLocationList.fulfilled, (state, action) => {
        state.minimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchDeliveryLocationList.rejected, (state, action) => {
        state.minimal = {
          status: "failed",
          data: [],
          error: action.error,
        };
      });
  },
});

export default deliveryLocationSlice.reducer;


